<template>
  <div class="hstack gap-4 bg-white pinyin-selection">
    <div
      v-for="p in pinyins"
      :key="p"
      class="cursor-pointer"
      :data-active="p === props.curPinyin"
      @mousedown.stop.prevent="props.onSelect(p)"
    >
      {{ convert(p) }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { pinyin, convert } from 'pinyin-pro'

const props = defineProps<{
  hanzi: string
  curPinyin: string
  onSelect: (pinyin: string) => void
}>()

const pinyins = pinyin(props.hanzi, {
  toneType: 'num',
  multiple: true,
  type: 'array',
})
</script>

<style scoped>
.pinyin-selection {
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);
  padding: 12px;
  border-radius: 8px;
}

.pinyin-selection > div[data-active='true'] {
  color: var(--primary-color);
}
</style>
